// import "./styles.css";
import React,{useState} from "react";
import { Chart as ChartJS, defaults } from "chart.js/auto";
import { Line } from 'react-chartjs-2';
import { months } from "moment/moment";

const sourceData=[
  {
    "label": "Ads",
    "value": 32
  },
  {
    "label": "Subscriptions",
    "value": 45
  },
  {
    "label": "Sponsorships",
    "value": 23
  }
]

const topperData=[
  {
    "label": "Jan",
    "topper": 80,
    "you": 10
  },
  {
    "label": "Feb",
    "topper": 90,
    "you": 42
  },
  {
    "label": "Mar",
    "topper": 98,
    "you": 52
  },
  {
    "label": "Apr",
    "topper": 70,
    "you": 64
  },
  {
    "label": "May",
    "topper": 85,
    "you": 58
  },
  {
    "label": "Jun",
    "topper": 96,
    "you": 83
  },
  {
    "label": "Jul",
    "topper": 89,
    "you": 74
  },
  // {
  //   "label": "Aug",
  //   "topper": 82919,
  //   "you": 37590
  // },
  // {
  //   "label": "Sep",
  //   "topper": 62407,
  //   "you": 43349
  // },
  // {
  //   "label": "Oct",
  //   "topper": 82528,
  //   "you": 45324
  // },
  // {
  //   "label": "Nov",
  //   "topper": 56979,
  //   "you": 47978
  // },
  // {
  //   "label": "Dec",
  //   "topper": 87436,
  //   "you": 39175
  // }
]
defaults.maintainAspectRatio = false;
defaults.responsive = true;

defaults.plugins.title.display = true;
defaults.plugins.title.align = "start";
defaults.plugins.title.font.size = 20;
defaults.plugins.title.color = "black";
export default function GraphAnalysis() {
  const [monthsDuration,setMonthsDuration]=useState("6 Months");
  return (
    <div style={{width:"100%",display:"flex",flexDirection:"column",justifyContent:"center ",height:"500px",padding:"3.5rem"}}>
      <div style={{width:"100%",display:"flex",justifyContent:"center ",alignItems:"center",columnGap:"1rem"}}>
      <div style={{display:"flex",columnGap:"0.5rem"}}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <circle cx="10" cy="10" r="10" fill="#004AAD"/>
</svg> <div>Toppers</div></div>
          <div style={{display:"flex",columnGap:"0.5rem"}}>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
  <circle cx="10.0327" cy="10" r="10" fill="#6DBA0A"/>
</svg> <div>You</div>
          </div>
          <div
                className="language_model"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {/* <div style={{ fontSize: "14px" }}>Time </div> */}
                <select
                 
                  value={monthsDuration}
                  onChange={(e) => {
                    setMonthsDuration(e.target.value);
                  }}
                  style={{
                    fontFamily: "'Figtree', sans-serif",
                    padding: "4px 10px",
                    boxSizing: "border-box",
                    borderRadius: "8px",
                    border: "1px solid #CED4DA",
                    background: "white",
                    cursor: "pointer",
                    outline: "none",
                  }}
                >
                  <option value="Week">Weekly</option>
                  <option value="Bi-weekly">Bi-weekly</option>
                  <option value="Month">Month</option>
                  <option value="6 Months">6 Months</option>
                  <option value="Year">Year</option>
                </select>
              </div>
      </div>
      <Line
          data={{
            labels: topperData.map((data) => data.label),
            datasets: [
              {
                label: "Topper",
                data: topperData.map((data) => data.topper),
                backgroundColor: "#381FD1",
                borderColor: "#381FD1",
              },
              {
                label: "You",
                data: topperData.map((data) => data.you),
                backgroundColor: "#6DBA0A",
                borderColor: "#6DBA0A",
              },
             
            ],
          }}
          options={{
            elements: {
              line: {
                tension: 0.4,
              },
            },
            plugins: {
              title: {
                text: "Preparation Time",
                // align:"center",
              },
              legend: {
                // display: false
              }
            },
            
          }
        }
        />
   
    </div>
  );
}
